(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 12436:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var debounce = __webpack_require__(54073),
    isObject = __webpack_require__(29259);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 87314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(64960);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 53157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _hooks_useLogger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8202);



var ClickLogger = function(props) {
    var children = props.children, _params = props.params, eventName = _params.eventName, payload = _params.payload, _enabled = props.enabled, enabled = _enabled === void 0 ? true : _enabled;
    var log = (0,_hooks_useLogger__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().log;
    var child = react__WEBPACK_IMPORTED_MODULE_1__.Children.only(children);
    var wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!enabled) {
            return;
        }
        var handleLog = function(_e) {
            var evaluatedPayload = typeof payload === "function" ? payload() : payload;
            log({
                eventName: eventName,
                payload: evaluatedPayload
            });
        };
        var wrapper = wrapperRef.current;
        if (wrapper) {
            wrapper.addEventListener("click", handleLog, {
                capture: true
            });
            return function() {
                wrapper.removeEventListener("click", handleLog, {
                    capture: true
                });
            };
        }
    }, [
        eventName,
        payload,
        log,
        enabled
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: wrapperRef,
        className: "contents",
        children: child
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ClickLogger);


/***/ }),

/***/ 64960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(4611);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/constants/logs/deeplink/index.ts
var deeplink = __webpack_require__(60643);
// EXTERNAL MODULE: ./src/shared/hooks/index.ts + 1 modules
var hooks = __webpack_require__(95613);
// EXTERNAL MODULE: ./src/styles/layout.ts
var layout = __webpack_require__(64952);
;// CONCATENATED MODULE: ./src/components/templates/landing/components/BottomBanner.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  height: 488px;\n\n  background: linear-gradient(86deg, #ff7501 28.16%, #ff8a01 96.29%);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  @media screen and (max-width: ",
        ") {\n    overflow: hidden;\n    background: linear-gradient(19deg, #ff7501 37.98%, #ff8801 96.07%);\n    height: 866px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 1080px;\n  display: flex;\n  flex-direction: column;\n  gap: 53px;\n  padding: 0 20px;\n  white-space: pre-wrap;\n\n  @media screen and (max-width: ",
        ") {\n    width: 300px;\n    align-items: center;\n    align-self: flex-start;\n    margin-top: 72px;\n    gap: 40px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 6px;\n  flex-direction: column;\n\n  @media screen and (max-width: ",
        ") {\n    gap: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 26px;\n  @media screen and (max-width: ",
        ") {\n    margin-bottom: 20px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #fff931;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 200px;\n  height: 56px;\n  border-radius: 12px;\n  padding: 0 12px;\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 30%;\n  bottom: -1px;\n  width: 520px;\n  object-fit: contain;\n  transform: translateX(50%);\n  @media screen and (max-width: ",
        ") {\n    right: 50%;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}





var BottomBanner = function() {
    var airbridgeDynamicLink = (0,hooks/* useAirbridgeDynamicLink */.e)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomBannerImg, {
                src: "https://file.doctornow.co.kr/landing/bottom_banner.png",
                alt: "하단 배너"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainCopyContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                className: "flex flex-col gap-[6px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainCopyHighlightText, {
                                        children: [
                                            "600만",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainCopyText, {
                                                children: "이 선택한 "
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MainBottomCopyText, {
                                        children: "대한민국 1위 비대면 진료 앱"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainPrizeText, {
                                children: "2025 한국소비자만족지수 비대면 진료앱 1위"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadButton, {
                        onClick: function() {
                            airbridgeDynamicLink.navigateWithTracking(deeplink/* DeeplinkLoggerEventName.ClickCtaButton */.l.ClickCtaButton, {
                                campaign: "web_home",
                                content: "web_content_bnr_main",
                                term: "앱 다운로드"
                            });
                        },
                        children: "앱 다운로드"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_BottomBanner = (BottomBanner);
var Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-705fd295-0"
})(_templateObject(), layout/* Tablet */.YD);
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-705fd295-1"
})(_templateObject1(), layout/* Tablet */.YD);
var MainCopyContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-705fd295-2"
})(_templateObject2(), layout/* Tablet */.YD);
var MainPrizeText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-705fd295-3"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), theme.typography.UI13M, theme.color.primary300);
});
var MainCopyText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-705fd295-4"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n      ".concat(theme.typography.UI56B, ";\n      color: ").concat(theme.color.white, ";\n      \n      @media screen and (max-width: ").concat(layout/* Tablet */.YD, ") { \n        text-align: center;\n          justify-content: center;\n\n        ").concat(theme.typography.UI36B, ";\n      } \n    ");
});
var MainBottomCopyText = (0,styled_components_browser_esm/* default */.ZP)(MainCopyText).withConfig({
    componentId: "sc-705fd295-5"
})(_templateObject6(), layout/* Tablet */.YD);
var MainCopyHighlightText = (0,styled_components_browser_esm/* default */.ZP)(MainCopyText).withConfig({
    componentId: "sc-705fd295-6"
})(_templateObject7());
var DownloadButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-705fd295-7"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.white, ";\n    color: ").concat(theme.color.primary600, ";\n    ").concat(theme.typography.UI17SB, ";\n  ");
});
var BottomBannerImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-705fd295-8"
})(_templateObject9(), layout/* Tablet */.YD);

;// CONCATENATED MODULE: ./src/components/templates/landing/components/BrandStorySection.tsx

function BrandStorySection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 100px 0 100px 0;\n  gap: 53px;\n  justify-content: center;\n  ",
        ";\n\n  @media screen and (max-width: ",
        ") {\n    gap: 32px;\n  }\n\n  \n"
    ]);
    BrandStorySection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BrandStorySection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: pre-wrap;\n  text-align: center;\n  ",
        ";\n  @media screen and (max-width: ",
        ") {\n    ",
        "\n  }\n"
    ]);
    BrandStorySection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BrandStorySection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    BrandStorySection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var BrandStorySection = function() {
    var ref = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BrandStory, {
        ref: ref,
        opacity: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandStoryText, {
                children: "병원 문 닫았다는 이유로\n바빠서 어쩔 수 없다는 이유로\n더 이상 아픔을 참거나 미루지 마세요."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BrandStoryText, {
                children: [
                    "아플 때, 닥터나우를 열면",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandStoryHighlightText, {
                        children: "병원이 우리를 찾아올 거예요."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_BrandStorySection = (BrandStorySection);
var BrandStory = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fcf819ae-0"
})(BrandStorySection_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.gray800, ";\n  ");
}, layout/* Tablet */.YD);
var BrandStoryText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fcf819ae-1"
})(BrandStorySection_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n     ".concat(theme.typography.UI32B, ";\n     color: ").concat(theme.color.white, "; \n    ");
}, layout/* Tablet */.YD, function(param) {
    var theme = param.theme;
    return "\n     ".concat(theme.typography.UI18B, ";\n    ");
});
var BrandStoryHighlightText = (0,styled_components_browser_esm/* default */.ZP)(BrandStoryText).withConfig({
    componentId: "sc-fcf819ae-2"
})(BrandStorySection_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    color: ".concat(theme.color.primary500, ";\n  ");
});

// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./node_modules/react-intersection-observer/index.mjs
"use client";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/InView.tsx


// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
function getRootId(root) {
  if (!root)
    return "0";
  if (RootIds.has(root))
    return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(
    (key) => options[key] !== void 0
  ).map((key) => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  let id = optionsToId(options);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const { id, observer, elements } = createObserver(options);
  let callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

// src/InView.tsx
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = class extends react.Component {
  constructor(props) {
    super(props);
    __publicField(this, "node", null);
    __publicField(this, "_unobserveCb", null);
    __publicField(this, "handleNode", (node) => {
      if (this.node) {
        this.unobserve();
        if (!node && !this.props.triggerOnce && !this.props.skip) {
          this.setState({ inView: !!this.props.initialInView, entry: void 0 });
        }
      }
      this.node = node ? node : null;
      this.observeNode();
    });
    __publicField(this, "handleChange", (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        this.unobserve();
      }
      if (!isPlainChildren(this.props)) {
        this.setState({ inView, entry });
      }
      if (this.props.onChange) {
        this.props.onChange(inView, entry);
      }
    });
    this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }
  componentWillUnmount() {
    this.unobserve();
    this.node = null;
  }
  observeNode() {
    if (!this.node || this.props.skip)
      return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(
      this.node,
      this.handleChange,
      {
        threshold,
        root,
        rootMargin,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      },
      fallbackInView
    );
  }
  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  }
  render() {
    const { children } = this.props;
    if (typeof children === "function") {
      const { inView, entry } = this.state;
      return children({ inView, entry, ref: this.handleNode });
    }
    const {
      as,
      triggerOnce,
      threshold,
      root,
      rootMargin,
      onChange,
      skip,
      trackVisibility,
      delay,
      initialInView,
      fallbackInView,
      ...props
    } = this.props;
    return React.createElement(
      as || "div",
      { ref: this.handleNode, ...props },
      children
    );
  }
};

// src/useInView.tsx

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _a;
  const [ref, setRef] = react.useState(null);
  const callback = react.useRef();
  const [state, setState] = react.useState({
    inView: !!initialInView,
    entry: void 0
  });
  callback.current = onChange;
  react.useEffect(
    () => {
      if (skip || !ref)
        return;
      let unobserve;
      unobserve = observe(
        ref,
        (inView, entry) => {
          setState({
            inView,
            entry
          });
          if (callback.current)
            callback.current(inView, entry);
          if (entry.isIntersecting && triggerOnce && unobserve) {
            unobserve();
            unobserve = void 0;
          }
        },
        {
          root,
          rootMargin,
          threshold,
          // @ts-ignore
          trackVisibility,
          // @ts-ignore
          delay
        },
        fallbackInView
      );
      return () => {
        if (unobserve) {
          unobserve();
        }
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      // eslint-disable-next-line react-hooks/exhaustive-deps
      Array.isArray(threshold) ? threshold.toString() : threshold,
      ref,
      root,
      rootMargin,
      triggerOnce,
      skip,
      trackVisibility,
      fallbackInView,
      delay
    ]
  );
  const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  const previousEntryTarget = react.useRef();
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  const result = [setRef, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

//# sourceMappingURL=index.mjs.map
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
;// CONCATENATED MODULE: ./src/components/templates/landing/components/ExposeLogger.tsx

function ExposeLogger_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ExposeLogger_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var ExposeLogger = function(param) {
    var label = param.label, client = param.client;
    var ref = useInView({
        triggerOnce: true
    }), inView = ref.inView, ref1 = ref.ref;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        if (inView) {
            (0,logger/* logger */.kg)({
                pageName: (0,logger/* getPageName */.j0)(router),
                eventName: "user_web_home_".concat(label, "_section_exposed"),
                payload: {
                    isMobile: String(client.isMobile)
                }
            });
        }
    }, [
        inView,
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        ref: ref1
    });
};
/* harmony default export */ var components_ExposeLogger = (ExposeLogger);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-82b068d-0"
})(ExposeLogger_templateObject());

;// CONCATENATED MODULE: ./src/components/atom/landing/CaretDown.tsx

var CaretDown = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M11.3594 5.3999L8.03125 8.82178L4.70312 5.3999L3.75 6.32178L8.03125 10.728L12.3125 6.32178L11.3594 5.3999Z",
            fill: "#8D9297"
        })
    });
};
/* harmony default export */ var landing_CaretDown = (CaretDown);

;// CONCATENATED MODULE: ./src/components/atom/landing/CaretUp.tsx

var CaretUp = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M11.625 10.6997L8.28125 7.27783L4.95312 10.6997L4 9.76221L8.28125 5.35596L12.5781 9.76221L11.625 10.6997Z",
            fill: "#8D9297"
        })
    });
};
/* harmony default export */ var landing_CaretUp = (CaretUp);

;// CONCATENATED MODULE: ./src/components/templates/landing/components/FaqItem.tsx

function FaqItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    FaqItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FaqItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    FaqItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FaqItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: underline;\n"
    ]);
    FaqItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FaqItem_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 0;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0;\n  width: 690px;\n  overflow: hidden;\n  border-radius: 8px 8px;\n\n  @media screen and (max-width: ",
        ") {\n    width: 100%;\n  }\n"
    ]);
    FaqItem_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function FaqItem_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  padding: 16px 19px 16px 20px;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  z-index: 3 !important;\n  ",
        "\n"
    ]);
    FaqItem_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function FaqItem_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    FaqItem_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function FaqItem_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    FaqItem_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function FaqItem_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 20px;\n  padding: 24px 25px;\n  display: flex;\n\n  ",
        "\n  ",
        ";\n  transition: margin-top 0.3s linear;\n"
    ]);
    FaqItem_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function FaqItem_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: pre-wrap;\n  ",
        "\n"
    ]);
    FaqItem_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}






var FaqItem = function(param) {
    var opened = param.opened, title = param.title, onClick = param.onClick, children = param.children;
    var ref = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(0), height = ref1[0], setHeight = ref1[1];
    (0,react.useEffect)(function() {
        if (!ref.current) {
            return;
        }
        setHeight(ref.current.clientHeight);
    }, [
        opened
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FaqItem_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                opened: opened,
                onClick: onClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleText, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QMark, {
                                children: "Q."
                            }),
                            title
                        ]
                    }),
                    opened ? /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_CaretUp, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_CaretDown, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper, {
                ref: ref,
                opened: opened,
                height: height,
                children: children
            })
        ]
    });
};
var FaqContentBlock = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBlock, {
        children: children
    });
};
FaqItem.ContentBlock = FaqContentBlock;
FaqItem.SmallText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-afd368d8-0"
})(FaqItem_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14R, ";\n    color: ").concat(theme.color.gray400, ";\n  ");
});
FaqItem.BoldText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-afd368d8-1"
})(FaqItem_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI16B, ";\n    color: ").concat(theme.color.gray400, ";\n  ");
});
FaqItem.Href = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-afd368d8-2"
})(FaqItem_templateObject2());
/* harmony default export */ var components_FaqItem = (FaqItem);
var FaqItem_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-afd368d8-3"
})(FaqItem_templateObject3(), layout/* Tablet */.YD);
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-afd368d8-4"
})(FaqItem_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI18SB, ";\n    color: ").concat(theme.color.gray500, ";\n    background: ").concat(theme.color.gray40, ";\n    flex-wrap: nowrap\n    \n  ");
});
var TitleText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-afd368d8-5"
})(FaqItem_templateObject5());
var QMark = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-afd368d8-6"
})(FaqItem_templateObject6(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI18SB, ";\n    color: ").concat(theme.color.primary800, ";\n  ");
});
var ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-afd368d8-7"
})(FaqItem_templateObject7(), function(param) {
    var opened = param.opened, height = param.height;
    return opened ? "\n      margin-top: 0;\n  " : "\n      margin-top: -".concat(height, "px;\n      ");
}, function(param) {
    var theme = param.theme;
    return "\n        background: ".concat(theme.color.gray20, ";\n    ");
});
var ContentBlock = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-afd368d8-8"
})(FaqItem_templateObject8(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI16R, ";\n    color: ").concat(theme.color.gray400, ";\n  ");
});

;// CONCATENATED MODULE: ./src/components/templates/landing/components/FaqSection.tsx

function FaqSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background: white;\n  padding: 120px 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  @media screen and (max-width: ",
        ") {\n    padding: 80px 10px;\n  }\n"
    ]);
    FaqSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FaqSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 1080px;\n  padding: 0;\n  flex-direction: column;\n  align-items: center;\n  gap: 96px;\n  flex-shrink: 0;\n\n  @media screen and (max-width: ",
        ") {\n    width: 100%;\n    gap: 40px;\n  }\n"
    ]);
    FaqSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FaqSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    FaqSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FaqSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 690px;\n  gap: 16px;\n\n  @media screen and (max-width: ",
        ") {\n    width: 100%;\n  }\n"
    ]);
    FaqSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var FaqSection = function(param) {
    var selectedFaqIndex = param.selectedFaqIndex, clickFaq = param.clickFaq;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqSection_Section, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentArea, {
            "data-aos": "fade-up",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqSection_Title, {
                    children: "자주 묻는 질문"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FaqList, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_FaqItem, {
                            onClick: function() {
                                return clickFaq(0);
                            },
                            opened: selectedFaqIndex === 0,
                            title: "비대면 진료는 누구나 가능한가요?",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FaqItem.ContentBlock, {
                                    children: "네, 가능해요! 2024년 2월 23일에 시행된 '비대면 진료 시범사업 지침 개정안 공고'에 따르면, 누구나 365일 24시간 내내 비대면 진료를 이용할 수 있어요.\n\n단, 의사의 판단에 따라 비대면 진료가 어려운 증상의 경우 진료가 취소될 수 있어요."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FaqItem.ContentBlock, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FaqItem.SmallText, {
                                        children: "※ 비대면 진료 시범사업 지침 개정안 공고(보건복지부 공고 제 2024-239호)"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FaqItem, {
                            onClick: function() {
                                return clickFaq(1);
                            },
                            opened: selectedFaqIndex === 1,
                            title: "비대면 진료는 화상으로만 진행되나요?",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FaqItem.ContentBlock, {
                                children: "비대면 진료는 화상진료 또는 음성진료 모두 가능해요.\n원하는 방식을 선택해 비대면 진료 받아보세요."
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_FaqItem, {
                            onClick: function() {
                                return clickFaq(2);
                            },
                            opened: selectedFaqIndex === 2,
                            title: "비대면 진료 후 처방전은 어떻게 받을 수 있나요?",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FaqItem.ContentBlock, {
                                    children: "비대면 진료가 끝나고 처방전을 받았다면, 해당 처방전을 전송할 약국을 선택해 달라는 화면이 노출돼요."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_FaqItem.ContentBlock, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FaqItem.BoldText, {
                                            children: "[앱으로 접수]"
                                        }),
                                        "'앱으로 접수' 뱃지가 붙은 약국은 닥터나우 제휴 약국으로, 따로 전화할 필요 없이 앱으로 처방전을 보내면 약 조제가 바로 시작되는 약국이에요."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_FaqItem.ContentBlock, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FaqItem.BoldText, {
                                            children: "[전화로 접수]"
                                        }),
                                        "닥터나우와 제휴하지 않는 약국에도 처방전을 보내고 약을 픽업해 올 수 있어요. 처방전을 보내기 전에 해당 약국에 전화한 후, 처방약의 조제 가능 여부를 확인하고 처방전을 전송하면 돼요."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FaqItem.ContentBlock, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FaqItem.SmallText, {
                                        children: "※ 근처 약국이 보이지 않는 경우 지도의 줌/아웃 기능을 이용해 위치를 변경한 후, \n[이 위치 재검색]을 누르면 더 많은 약국을 조회할 수 있어요.\n※ 닥터나우 앱을 통해 전송되는 처방전은 병원 전산 시스템과 연동된 처방전 원본이에요."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FaqItem, {
                            onClick: function() {
                                return clickFaq(3);
                            },
                            opened: selectedFaqIndex === 3,
                            title: "처방전 다운로드 또는 출력이 가능한가요?",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FaqItem.ContentBlock, {
                                children: "아니요. 현재 보건복지부 시범사업안에 따라, 비대면 진료 후 발급된 처방전은 위\xb7변조 방지를 위해 원본을 다운로드하거나 출력할 수 없어요.\n\n닥터나우 앱을 통해 약국에 처방전을 보내면 복지부 가이드에 맞춰 팩스가 자동 전송돼요. 따라서, 처방전을 따로 출력해 약국에 가져가지 않아도 처방약을 받을 수 있어요."
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_FaqItem, {
                            onClick: function() {
                                return clickFaq(4);
                            },
                            opened: selectedFaqIndex === 4,
                            title: "비대면 진료로 어떤 약이든 처방 받을 수 있나요?",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FaqItem.ContentBlock, {
                                    children: "보건복지부 시범사업안에 따라 마약류, 오\xb7남용 의약품, 사후피임약은 비대면 진료를 통해 처방받을 수 없어요. 보다 자세한 내용이 궁금하다면 아래 문서를 확인해 주세요."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FaqItem.ContentBlock, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FaqItem.SmallText, {
                                        children: "※「마약류 관리에 관한 법률」제 18조 제 2항, 제 21조 제 2항에 따라 마약 및 향정신성\n의약품으로 수입\xb7제조허가를 받은 의약품\n※「오\xb7남용 우려 의약품 지정에 관한 규정」(식약처) 지정 품목(23개 품목(성분) 함유제제)\n※ 사후피임약 : 레보노르게스트렐(0.75mg, 1.5mg), 울리프리스탈(30mg) 함유제제"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FaqItem.ContentBlock, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FaqItem.Href, {
                                        children: "비대면진료 처방제한 의약품.pdf"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_FaqSection = (FaqSection);
var FaqSection_Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-29efb4de-0"
})(FaqSection_templateObject(), layout/* Tablet */.YD);
var ContentArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-29efb4de-1"
})(FaqSection_templateObject1(), layout/* Tablet */.YD);
var FaqSection_Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-29efb4de-2"
})(FaqSection_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n        ".concat(theme.typography.UI48B, ";\n        color: ").concat(theme.color.gray900, ";\n        \n        @media screen and (max-width: ").concat(layout/* Tablet */.YD, ") {\n          ").concat(theme.typography.UI32B, ";\n        }\n    ");
});
var FaqList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-29efb4de-3"
})(FaqSection_templateObject3(), layout/* Tablet */.YD);

;// CONCATENATED MODULE: ./src/components/atom/icon/DoctornowLogo.tsx

var DoctornowLogo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "120",
        height: "26",
        viewBox: "0 0 120 26",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_113_2294)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                        id: "mask0_113_2294",
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0",
                        width: "120",
                        height: "26",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M120 0.253418H0V25.747H120V0.253418Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        mask: "url(#mask0_113_2294)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M49.656 3.63954C49.656 2.62268 48.8406 1.79834 47.8344 1.79834C46.8283 1.79834 46.0127 2.62268 46.0127 3.63954V12.8456C46.0127 13.8624 46.8283 14.6868 47.8344 14.6868C48.8406 14.6868 49.656 13.8624 49.656 12.8456V9.72967H50.7771C51.7057 9.72967 52.4586 8.96875 52.4586 8.03011C52.4586 7.09145 51.7057 6.33053 50.7771 6.33053H49.656V3.63954Z",
                                fill: "#FD7E14"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M41.3185 2.36523C42.2084 2.36523 42.9299 3.09445 42.9299 3.99399C42.9299 4.89354 42.2084 5.62276 41.3185 5.62276H34.8025V10.5798H43C43.89 10.5798 44.6115 11.309 44.6115 12.2086C44.6115 13.1081 43.89 13.8373 43 13.8373H32.8406C31.912 13.8373 31.1592 13.0764 31.1592 12.1378V4.06481C31.1592 3.12615 31.912 2.36523 32.8406 2.36523H41.3185Z",
                                fill: "#FD7E14"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M32.8398 17.0946C32.8398 16.2342 33.5301 15.5366 34.3812 15.5366H47.9738C48.9024 15.5366 49.6552 16.2976 49.6552 17.2362V22.6182C49.6552 23.6351 48.8398 24.4593 47.8336 24.4593C46.8275 24.4593 46.0119 23.6351 46.0119 22.6182V18.6525H34.3812C33.5301 18.6525 32.8398 17.955 32.8398 17.0946Z",
                                fill: "#FD7E14"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M66.1906 4.27719C66.1906 3.37765 65.4692 2.64844 64.5791 2.64844H56.1014C55.1728 2.64844 54.4199 3.40936 54.4199 4.34801V19.2192C54.4199 20.1579 55.1728 20.9188 56.1014 20.9188H65.9805C66.8705 20.9188 67.592 20.1896 67.592 19.2901C67.592 18.3905 66.8705 17.6614 65.9805 17.6614H58.0633V13.2708H63.1779C64.068 13.2708 64.7894 12.5416 64.7894 11.642C64.7894 10.7425 64.068 10.0132 63.1779 10.0132H58.0633V5.90594H64.5791C65.4692 5.90594 66.1906 5.17673 66.1906 4.27719Z",
                                fill: "#FD7E14"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M71.5158 1.93994C72.5218 1.93994 73.3373 2.76428 73.3373 3.78113V22.6181C73.3373 23.635 72.5218 24.4592 71.5158 24.4592C70.5096 24.4592 69.6941 23.635 69.6941 22.6181V13.1288H67.452C66.5234 13.1288 65.7705 12.3679 65.7705 11.4292C65.7705 10.4906 66.5234 9.72963 67.452 9.72963H69.6941V3.78113C69.6941 2.76428 70.5096 1.93994 71.5158 1.93994Z",
                                fill: "#FD7E14"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M80.2039 4.48965C80.2039 3.47277 79.3883 2.64844 78.3822 2.64844C77.3762 2.64844 76.5605 3.47277 76.5605 4.48965V18.9361C76.5605 19.8747 77.3134 20.6355 78.2422 20.6355H88.1211C89.0111 20.6355 89.7326 19.9064 89.7326 19.0068C89.7326 18.1072 89.0111 17.3781 88.1211 17.3781H80.2039V4.48965Z",
                                fill: "#FD7E14"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M92.9553 1.79834C93.9615 1.79834 94.777 2.62268 94.777 3.63954V9.58805H95.9682C96.9355 9.58805 97.7197 10.3807 97.7197 11.3584C97.7197 12.3362 96.9355 13.1288 95.9682 13.1288H94.777V22.6181C94.777 23.635 93.9615 24.4593 92.9553 24.4593C91.9493 24.4593 91.1338 23.635 91.1338 22.6181V3.63954C91.1338 2.62268 91.9493 1.79834 92.9553 1.79834Z",
                                fill: "#FD7E14"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M105.146 2.08154C102.36 2.08154 100.102 4.3643 100.102 7.18024V7.74677C100.102 10.5627 102.36 12.8455 105.146 12.8455H113.414C116.2 12.8455 118.458 10.5627 118.458 7.74677V7.18024C118.458 4.3643 116.2 2.08154 113.414 2.08154H105.146ZM112.573 5.19742H105.987C104.903 5.19742 103.745 6.08517 103.745 7.18024V7.74677C103.745 8.84185 104.903 9.7296 105.987 9.7296H112.573C113.656 9.7296 114.815 8.84185 114.815 7.74677V7.18024C114.815 6.08517 113.656 5.19742 112.573 5.19742Z",
                                fill: "#FD7E14"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M98.5605 16.3157C98.5605 15.4162 99.282 14.687 100.172 14.687H118.389C119.279 14.687 120 15.4162 120 16.3157C120 17.2154 119.279 17.9445 118.389 17.9445H111.312V22.6184C111.312 23.6353 110.497 24.4595 109.49 24.4595C108.484 24.4595 107.669 23.6353 107.669 22.6184V17.9445H100.172C99.282 17.9445 98.5605 17.2154 98.5605 16.3157Z",
                                fill: "#FD7E14"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                opacity: "0.46",
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M17.7683 13.0351C17.7683 11.9879 16.9192 11.1389 15.872 11.1389H14.6079V9.87474C14.6079 8.82753 13.7588 7.97852 12.7116 7.97852C11.6644 7.97852 10.8154 8.82753 10.8154 9.87474V13.0351C10.8154 13.9889 11.5198 14.7785 12.4368 14.9114C12.5264 14.9243 12.6182 14.9313 12.7116 14.9313H15.872C16.9192 14.9313 17.7683 14.0823 17.7683 13.0351Z",
                                fill: "#FD7E14"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M7.72559 12.9651C7.72559 14.0123 8.5746 14.8613 9.6218 14.8613H10.8859V16.1254C10.8859 17.1727 11.735 18.0216 12.7822 18.0216C13.8294 18.0216 14.6784 17.1727 14.6784 16.1254V12.9651C14.6784 11.9507 13.8817 11.1224 12.8799 11.0716C12.8717 11.0712 12.8639 11.0708 12.8557 11.0704C12.8314 11.0696 12.8068 11.0688 12.7822 11.0688H9.6218C8.5746 11.0688 7.72559 11.9179 7.72559 12.9651Z",
                                fill: "#FD7E14"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M11.9665 0.253418H5.40034C3.02659 0.253418 1.10235 2.17656 1.10235 4.54893V6.11547C0.434318 6.6017 0 7.38964 0 8.27919C0 9.75658 1.19856 10.9544 2.6768 10.9544C4.15503 10.9544 5.35359 9.75658 5.35359 8.27919C5.35359 7.32191 4.85034 6.4818 4.09388 6.0092V4.54893C4.09388 3.82795 4.67856 3.24322 5.40034 3.24322H11.9669C17.3584 3.24322 21.7291 7.61155 21.7291 12.9998C21.7291 18.3881 17.3584 22.7564 11.9669 22.7564H5.40034C4.67894 22.7564 4.09388 22.172 4.09388 21.4507V19.9904C4.85034 19.5178 5.35359 18.6778 5.35359 17.7205C5.35359 16.243 4.15503 15.0452 2.6768 15.0452C1.19856 15.0452 0 16.2435 0 17.7213C0 18.6104 0.434318 19.3983 1.10235 19.8849V21.4515C1.10235 23.8238 3.02659 25.747 5.40034 25.747H11.9669C19.0107 25.747 24.7211 20.0403 24.7211 13.0002C24.7211 5.96014 19.0107 0.253418 11.9665 0.253418Z",
                                fill: "#FD7E14"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_113_2294",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "120",
                        height: "26",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icon_DoctornowLogo = (DoctornowLogo);

// EXTERNAL MODULE: ./src/constants/common/index.ts
var common = __webpack_require__(95611);
// EXTERNAL MODULE: ./src/entities/medical-category/index.ts + 4 modules
var medical_category = __webpack_require__(7551);
// EXTERNAL MODULE: ./src/entities/telemedicine/index.ts + 6 modules
var telemedicine = __webpack_require__(42491);
// EXTERNAL MODULE: ./src/utils/style.ts
var style = __webpack_require__(76666);
// EXTERNAL MODULE: ../../node_modules/lodash/throttle.js
var throttle = __webpack_require__(12436);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/templates/landing/components/MainHeader.tsx

function MainHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: fixed;\n    top: 0;\n    z-index: 200;\n    width: 100%;\n    overflow-y: hidden;\n    height: 80px;\n    background-image: ",
        ";\n    &:hover {\n        height: auto;\n        background-image: ",
        ";\n    }\n"
    ]);
    MainHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MainHeader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & li:before, & li:after {\n    display: none;\n    float: none;\n  }\n"
    ]);
    MainHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var styles = {
    topItemWrapper: (0,style.cn)([
        "h-[80px] flex items-center px-[8px]"
    ]),
    listItemWrapper: (0,style.cn)([
        "flex flex-col"
    ]),
    subMenusWrapper: (0,style.cn)([
        "pt-[20px] pb-[40px] flex flex-col gap-[12px]"
    ])
};
var routes = {
    "비대면 진료": {
        subMenus: common/* TELEMEDICINE_SUBMENUS */.Lb
    },
    "병원 찾기": {
        subMenus: common/* HOSPITAL_SUBMENUS */.Oi
    },
    "비급여 가격": {
        subMenus: common/* NON_BENEFIT_SUBMENUS */.J$
    },
    "건강 정보": {
        subMenus: common/* MAGAZINE_SUBMENUS */.ld
    },
    "실시간 의료 상담": {
        subMenus: common/* QNA_SUBMENUS */.Up
    }
};
var routerKeys = Object.keys(routes);
var HEADER_HEIGHT = 80;
var isTelemedicineRequestAvailable = function(subMenu) {
    return Boolean(subMenu.categoryId && subMenu.categoryId !== "ALL" && subMenu.categoryType !== null && subMenu.categoryType !== undefined);
};
var MainHeader = function() {
    var airbridgeDynamicLink = (0,hooks/* useAirbridgeDynamicLink */.e)();
    var onClickTelemedicineRequest = (0,telemedicine/* useTelemedicineRequest */.UO)().onClickTelemedicineRequest;
    var ref = (0,react.useState)(false), scrolled = ref[0], setScrolled = ref[1];
    var getRouteSubMenus = function(key) {
        return routes[key].subMenus || [];
    };
    var onClickSubMenu = function(subMenu, e) {
        e.preventDefault();
        if (!isTelemedicineRequestAvailable(subMenu)) {
            return;
        }
        var _categoryType;
        onClickTelemedicineRequest({
            categoryId: subMenu.categoryId,
            type: (_categoryType = subMenu.categoryType) !== null && _categoryType !== void 0 ? _categoryType : medical_category/* EMedicalCategoryType.DEPARTMENT */.m1.DEPARTMENT,
            redirectUrl: (0,telemedicine/* getCategoryPath */.IX)(subMenu.categoryId, subMenu.categoryType)
        });
    };
    var onClickAppDownload = function() {
        airbridgeDynamicLink.navigateWithTracking(deeplink/* DeeplinkLoggerEventName.ClickCtaButton */.l.ClickCtaButton, {
            campaign: "web_home",
            content: "web_gnb_btn_main",
            term: "앱 다운로드"
        });
    };
    (0,react.useEffect)(function() {
        var handleScroll = throttle_default()(function() {
            var isScrolled = window.scrollY > HEADER_HEIGHT;
            setScrolled(isScrolled);
        }, 100);
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
        scrolled: scrolled,
        className: (0,style.cn)([
            "text-gray-700 hover:text-gray-700"
        ]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "relative z-10 mx-auto flex w-full max-w-[1080px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,style.cn)([
                        styles.topItemWrapper,
                        "mr-[48px]"
                    ]),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_DoctornowLogo, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "flex gap-[48px]",
                        children: routerKeys.map(function(routerKey) {
                            var routeSubMenus = getRouteSubMenus(routerKey);
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,style.cn)([
                                            styles.topItemWrapper,
                                            "top-item"
                                        ]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,style.cn)("typography-ui-17sb flex h-full items-center hover:text-primary-600", scrolled && "text-gray-700"),
                                            children: routerKey
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: styles.subMenusWrapper,
                                        children: routeSubMenus.map(function(routerSubMenu) {
                                            var shouldUseTelemedicineRequest = routerKey === "비대면 진료" && isTelemedicineRequestAvailable(routerSubMenu);
                                            if (shouldUseTelemedicineRequest) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        role: "button",
                                                        className: (0,style.cn)([
                                                            "typography-ui-17r flex h-[36px] cursor-pointer items-center rounded-[4px] px-[8px] py-[6px] text-gray-600",
                                                            "hover:typography-ui-17m hover:bg-gray-30 hover:text-gray-700", 
                                                        ]),
                                                        onClick: function(e) {
                                                            return onClickSubMenu(routerSubMenu, e);
                                                        },
                                                        children: routerSubMenu.text
                                                    })
                                                }, "subMenu-".concat(routerSubMenu.text));
                                            }
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: routerSubMenu.url,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: (0,style.cn)([
                                                            "typography-ui-17r flex h-[36px] items-center rounded-[4px] px-[8px] py-[6px] text-gray-600",
                                                            "hover:typography-ui-17m hover:bg-gray-30 hover:text-gray-700", 
                                                        ]),
                                                        children: routerSubMenu.text
                                                    })
                                                })
                                            }, "subMenu-".concat(routerSubMenu.text));
                                        })
                                    })
                                ]
                            }, "route-".concat(routerKey));
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "ml-auto py-[16px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "ty typography-ui-17sb h-[48px] rounded-[12px] bg-primary-600 px-[16px] text-white",
                        onClick: onClickAppDownload,
                        children: "앱 다운로드"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_MainHeader = (MainHeader);
var Header = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-99197045-0"
})(MainHeader_templateObject(), function(param) {
    var theme = param.theme, scrolled = param.scrolled;
    return scrolled ? "linear-gradient(to bottom, ".concat(theme.color.white, " 80px, ").concat(theme.color.gray10, " 80px, ").concat(theme.color.gray10, " 100%)") : "none";
}, function(param) {
    var theme = param.theme;
    return "linear-gradient(to bottom, ".concat(theme.color.white, " 80px, ").concat(theme.color.gray10, " 80px, ").concat(theme.color.gray10, " 100%)");
});
var Nav = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-99197045-1"
})(MainHeader_templateObject1());

;// CONCATENATED MODULE: ./src/components/atom/landing/StarIcon.tsx

var StarIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M10.7038 1.72538C11.2824 0.731982 12.7176 0.731982 13.2962 1.72538L16.0316 6.42187C16.2436 6.78577 16.5987 7.04382 17.0103 7.13294L22.3223 8.28322C23.4458 8.52653 23.8893 9.89142 23.1233 10.7487L19.502 14.8015C19.2214 15.1156 19.0858 15.5331 19.1282 15.9521L19.6757 21.3595C19.7915 22.5033 18.6304 23.3468 17.5784 22.8832L12.6049 20.6915C12.2195 20.5217 11.7805 20.5217 11.3951 20.6915L6.42157 22.8832C5.36956 23.3468 4.20852 22.5033 4.32432 21.3595L4.87182 15.9521C4.91424 15.5331 4.77858 15.1156 4.49799 14.8015L0.876664 10.7487C0.110682 9.89142 0.554161 8.52653 1.67774 8.28322L6.98967 7.13294C7.40126 7.04382 7.75642 6.78577 7.96838 6.42187L10.7038 1.72538Z",
            fill: "#FF8D00"
        })
    });
};
/* harmony default export */ var landing_StarIcon = (StarIcon);

;// CONCATENATED MODULE: ./src/components/templates/landing/components/ReviewSection.tsx

function ReviewSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 96px 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 72px;\n\n  ",
        " @media screen and (\n    max-width: ",
        ") {\n    padding: 80px 0;\n  }\n"
    ]);
    ReviewSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ReviewSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding-bottom: 0;\n  flex-direction: column;\n  align-items: center;\n  gap: 48px;\n\n  @media screen and (max-width: ",
        ") {\n    gap: 32px;\n  }\n"
    ]);
    ReviewSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ReviewSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  display: inline-block;\n  white-space: pre-wrap;\n  ",
        "\n"
    ]);
    ReviewSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ReviewSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    ReviewSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ReviewSection_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 0;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n"
    ]);
    ReviewSection_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ReviewSection_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 0;\n  align-items: flex-start;\n  gap: 20px;\n"
    ]);
    ReviewSection_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ReviewSection_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 0;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 12px;\n"
    ]);
    ReviewSection_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ReviewSection_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    ReviewSection_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ReviewSection_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 0;\n  align-items: center;\n  gap: 8px;\n"
    ]);
    ReviewSection_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function ReviewSection_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 0;\n  align-items: flex-end;\n  gap: 2px;\n"
    ]);
    ReviewSection_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 5%;\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 1px;\n  align-self: stretch;\n  background: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: center;\n  text-align: center;\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overscroll-behavior-x: contain;\n  width: 100%;\n  display: flex;\n  padding: 0;\n  align-items: center;\n  gap: 20px;\n  overflow: hidden;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 0;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n\n  ",
        " {\n    padding-bottom: 20px;\n  }\n\n  ",
        ":last-child {\n    padding-bottom: 40px;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    from {\n        right: 0;\n    }\n    to {\n        right: 3000px;\n    }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    from {\n        right: 0;\n    }\n    to {\n        right: 2220px;\n    }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    from {\n        left: -3000px;\n    }\n    to {\n        left: 0;\n    }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    from {\n        left: -2220px;\n    }\n    to {\n        left: 0;\n    }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n\n  animation: ",
        " 20s linear infinite;\n\n  @media screen and (max-width: ",
        ") {\n    animation: ",
        " 20s linear infinite;\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        " 20s linear infinite;\n\n  @media screen and (max-width: ",
        ") {\n    animation: ",
        " 20s linear infinite;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row-reverse;\n  gap: 20px;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 0 0 auto;\n  width: 480px;\n  padding: 32px;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  align-self: stretch;\n  border-radius: 20px;\n  background-color: white;\n  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.12);\n\n  @media screen and (max-width: ",
        ") {\n    width: 350px;\n    padding: 24px;\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n\n  @media screen and (max-width: ",
        ") {\n    gap: 4px;\n  }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 24px;\n  height: 24px;\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 8px;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  border-radius: 7px;\n\n  ",
        "\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  word-break: break-all;\n  ",
        "\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n\n  @media screen and (max-width: ",
        ") {\n    gap: 8px;\n  }\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}




var ReviewSection = function(param) {
    var nestedReviews = param.nestedReviews;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReviewSection_Section, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReviewSection_Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReviewSection_Title, {
                        children: [
                            "닥터나우는\n수많은 분들의 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight, {
                                children: "신뢰를 받고 있어요"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Summary, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryContent, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryContentBox, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                                children: "평점"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RateRow, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_StarIcon, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RateBox, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BigRate, {
                                                                children: "4.8"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallRate, {
                                                                children: "/5"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Separator, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryContentBox, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                                children: "닥터나우 진료 후기 수"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewCount, {
                                                children: "250,000+"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryAsOf, {
                                children: [
                                    "* 구글플레이, 앱스토어 평점",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "2024년 12월 기준"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReviewRows, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RowViewPort, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RowContainer, {
                                    children: nestedReviews[0].map(function(review, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Review, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReviewBox, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TagAndTitle, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tag, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TagLogo, {
                                                                            src: review.icon,
                                                                            alt: review.alt
                                                                        }),
                                                                        review.tag
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewTitle, {
                                                                    children: review.title
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewContent, {
                                                            children: review.content
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewAuthor, {
                                                    children: review.author
                                                })
                                            ]
                                        }, "review-".concat(review.author, "-").concat(review.title, "-").concat(index));
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RowContainer, {
                                    children: nestedReviews[0].map(function(review, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Review, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReviewBox, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TagAndTitle, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tag, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TagLogo, {
                                                                            src: review.icon,
                                                                            alt: review.alt
                                                                        }),
                                                                        review.tag
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewTitle, {
                                                                    children: review.title
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewContent, {
                                                            children: review.content
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewAuthor, {
                                                    children: review.author
                                                })
                                            ]
                                        }, "review-".concat(review.author, "-").concat(review.title, "-").concat(index));
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RowViewPort, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReverseRow, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RowContainer, {
                                    children: nestedReviews[1].map(function(review, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Review, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReviewBox, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TagAndTitle, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tag, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TagLogo, {
                                                                            src: review.icon,
                                                                            alt: review.alt
                                                                        }),
                                                                        review.tag
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewTitle, {
                                                                    children: review.title
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewContent, {
                                                            children: review.content
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewAuthor, {
                                                    children: review.author
                                                })
                                            ]
                                        }, "review-".concat(review.author, "-").concat(review.title, "-").concat(index));
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RowContainer, {
                                    children: nestedReviews[1].map(function(review, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Review, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReviewBox, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TagAndTitle, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tag, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TagLogo, {
                                                                            src: review.icon,
                                                                            alt: review.alt
                                                                        }),
                                                                        review.tag
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewTitle, {
                                                                    children: review.title
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewContent, {
                                                            children: review.content
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewAuthor, {
                                                    children: review.author
                                                })
                                            ]
                                        }, "review-".concat(review.author, "-").concat(review.title, "-").concat(index));
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_ReviewSection = (ReviewSection);
var ReviewSection_Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4238ca9e-0"
})(ReviewSection_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.gray40, ";\n  ");
}, layout/* Tablet */.YD);
var ReviewSection_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4238ca9e-1"
})(ReviewSection_templateObject1(), layout/* Tablet */.YD);
var ReviewSection_Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-4238ca9e-2"
})(ReviewSection_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n        ".concat(theme.typography.UI48B, ";\n        color: ").concat(theme.color.gray900, ";\n        \n      @media screen and (max-width: ").concat(layout/* Tablet */.YD, ") {\n          width: 300px;\n          text-align: left;\n          display: flex;\n          flex-direction:column;\n          align-self:flex-start;\n          ").concat(theme.typography.UI32B, ";\n        }\n    ");
});
var Highlight = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-4238ca9e-3"
})(ReviewSection_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n        color: ".concat(theme.color.primary700, ";\n    ");
});
var Summary = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4238ca9e-4"
})(ReviewSection_templateObject4());
var SummaryContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4238ca9e-5"
})(ReviewSection_templateObject5());
var SummaryContentBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4238ca9e-6"
})(ReviewSection_templateObject6());
var Label = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4238ca9e-7"
})(ReviewSection_templateObject7(), function(param) {
    var theme = param.theme;
    return "\n      ".concat(theme.typography.UI20SB, ";\n      color: ").concat(theme.color.gray500, ";\n      \n    @media screen and (max-width: ").concat(layout/* Tablet */.YD, ") {\n       ").concat(theme.typography.UI16SB, ";\n      }\n    ");
});
var RateRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4238ca9e-8"
})(ReviewSection_templateObject8());
var RateBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4238ca9e-9"
})(ReviewSection_templateObject9());
var BigRate = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4238ca9e-10"
})(_templateObject10(), function(param) {
    var theme = param.theme;
    return "\n      ".concat(theme.typography.UI40B, ";\n      color: ").concat(theme.color.gray700, ";\n      \n      @media screen and (max-width: ").concat(layout/* Tablet */.YD, ") {\n         ").concat(theme.typography.UI32B, ";\n      }\n    ");
});
var SmallRate = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4238ca9e-11"
})(_templateObject11(), function(param) {
    var theme = param.theme;
    return "\n      ".concat(theme.typography.UI20B, ";\n      color: ").concat(theme.color.gray700, ";\n      \n        @media screen and (max-width: ").concat(layout/* Tablet */.YD, ") {\n         ").concat(theme.typography.UI17B, ";\n      }\n    ");
});
var Separator = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4238ca9e-12"
})(_templateObject12(), function(param) {
    var theme = param.theme;
    return theme.color.gray100;
});
var ReviewCount = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4238ca9e-13"
})(_templateObject13(), function(param) {
    var theme = param.theme;
    return "\n      ".concat(theme.typography.UI40B, ";\n      color: ").concat(theme.color.gray700, ";\n      \n      @media screen and (max-width: ").concat(layout/* Tablet */.YD, ") {\n      ").concat(theme.typography.UI32B, ";\n      }\n    ");
});
var SummaryAsOf = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4238ca9e-14"
})(_templateObject14(), function(param) {
    var theme = param.theme;
    return "\n     ".concat(theme.typography.UI16R, ";\n     color: ").concat(theme.color.gray300, ";\n     \n     @media screen and (max-width: ").concat(layout/* Tablet */.YD, "){\n      align-self: flex-start;\n      ").concat(theme.typography.UI13R, ";\n     }\n    ");
});
var RowViewPort = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4238ca9e-15"
})(_templateObject15());
var ReviewRows = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4238ca9e-16"
})(_templateObject16(), RowViewPort, RowViewPort);
var scrollLeftPc = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject17());
var scrollLeftMobile = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject18());
var scrollRightPc = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject19());
var scrollRightMobile = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject20());
var Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4238ca9e-17"
})(_templateObject21(), scrollLeftPc, layout/* Tablet */.YD, scrollLeftMobile);
var ReverseRow = (0,styled_components_browser_esm/* default */.ZP)(Row).withConfig({
    componentId: "sc-4238ca9e-18"
})(_templateObject22(), scrollRightPc, layout/* Tablet */.YD, scrollRightMobile);
var RowContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4238ca9e-19"
})(_templateObject23());
var Review = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4238ca9e-20"
})(_templateObject24(), layout/* Tablet */.YD);
var TagAndTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4238ca9e-21"
})(_templateObject25(), layout/* Tablet */.YD);
var TagLogo = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-4238ca9e-22"
})(_templateObject26());
var Tag = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4238ca9e-23"
})(_templateObject27(), function(param) {
    var theme = param.theme;
    return "\n      background ".concat(theme.color.gray20, ";\n\n      ").concat(theme.typography.UI16SB, ";\n      color: ").concat(theme.color.gray500, ";\n      \n       @media screen and (max-width: ").concat(layout/* Tablet */.YD, ") {\n        ").concat(theme.typography.UI14SB, ";\n        padding: 6px;\n      }\n    ");
});
var ReviewTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4238ca9e-24"
})(_templateObject28(), function(param) {
    var theme = param.theme;
    return "\n      ".concat(theme.typography.UI20B, ";\n      color: ").concat(theme.color.gray700, ";\n      \n       @media screen and (max-width: ").concat(layout/* Tablet */.YD, ") {\n        ").concat(theme.typography.UI18B, ";\n      }\n    ");
});
var ReviewContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4238ca9e-25"
})(_templateObject29(), function(param) {
    var theme = param.theme;
    return "\n      ".concat(theme.typography.UI17R, ";\n      color: ").concat(theme.color.gray500, ";\n      \n     @media screen and (max-width: ").concat(layout/* Tablet */.YD, ") {\n        ").concat(theme.typography.UI15R, ";\n      }\n    ");
});
var ReviewBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4238ca9e-26"
})(_templateObject30(), layout/* Tablet */.YD);
var ReviewAuthor = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4238ca9e-27"
})(_templateObject31(), function(param) {
    var theme = param.theme;
    return "\n      ".concat(theme.typography.UI15R, ";\n      color: ").concat(theme.color.gray400, ";\n      \n      @media screen and (max-width: ").concat(layout/* Tablet */.YD, ") {\n        ").concat(theme.typography.UI13R, ";\n      }\n    ");
});

;// CONCATENATED MODULE: ./src/components/templates/landing/components/ServiceCardSection.tsx

function ServiceCardSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 100px 0 120px 0;\n  flex-direction: column;\n  align-items: center;\n  gap: 68px;\n  background: ",
        ";\n\n  @media screen and (max-width: ",
        ") {\n    gap: 40px;\n    padding: 80px 0;\n  }\n"
    ]);
    ServiceCardSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ServiceCardSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: pre-wrap;\n  text-align: center;\n  ",
        "\n"
    ]);
    ServiceCardSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ServiceCardSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  max-width: 1080px;\n  padding: 0 20px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 32px;\n  word-break: keep-all;\n\n  @media screen and (max-width: ",
        ") {\n    gap: 20px;\n  }\n"
    ]);
    ServiceCardSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ServiceCardSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  padding: 0;\n  justify-content: space-between;\n  gap: 32px;\n  align-self: stretch;\n\n  @media screen and (max-width: ",
        ") {\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 20px;\n  }\n"
    ]);
    ServiceCardSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ServiceCardSection_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 32px;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n\n  flex: 1;\n  border-radius: 12px;\n  background: white;\n  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.04);\n\n  @media screen and (max-width: ",
        ") {\n    width: 100%;\n    flex-direction: column;\n    gap: 15px;\n  }\n"
    ]);
    ServiceCardSection_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ServiceCardSection_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 64px;\n  height: 64px;\n  align-self: center;\n\n  @media screen and (max-width: ",
        ") {\n    align-self: flex-end;\n  }\n"
    ]);
    ServiceCardSection_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ServiceCardSection_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 24px;\n  height: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n  white-space: pre-wrap;\n"
    ]);
    ServiceCardSection_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ServiceCardSection_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n"
    ]);
    ServiceCardSection_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ServiceCardSection_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    ServiceCardSection_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function ServiceCardSection_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    ServiceCardSection_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function ServiceCardSection_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 48px;\n  padding: 0 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  align-self: flex-start;\n  border-radius: 8px;\n  ",
        "\n"
    ]);
    ServiceCardSection_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}



var ServiceCardSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceCardSection_Section, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceCardSection_Title, {
                "data-aos": "fade-up",
                children: "닥터나우,\n이렇게 활용해보세요"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceCardContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceCardSection_Row, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceCard, {
                                "data-aos": "fade-up",
                                href: "https://doctornow.co.kr/content/qna/realtime",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceCardContent, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceCardTextBox, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceDescription, {
                                                        children: "5분 만에 받아보는\n의료 답변"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceTitle, {
                                                        children: "실시간 의료 상담"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                                children: "바로 가기"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                        src: "https://file.doctornow.co.kr/landing/chat-bubble-icon.png",
                                        alt: "실시간 의료 상담 아이콘"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceCard, {
                                "data-aos": "fade-up",
                                href: "https://doctornow.co.kr/content/magazine",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceCardContent, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceCardTextBox, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceDescription, {
                                                        children: "에디터가 엄선한\n건강 가이드"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceTitle, {
                                                        children: "건강 매거진"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                                children: "바로 가기"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                        src: "https://file.doctornow.co.kr/landing/magazine-icon.png",
                                        alt: "건강 매거진 아이콘"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceCardSection_Row, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceCard, {
                                "data-aos": "fade-up",
                                href: "https://doctornow.co.kr/hospitals",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceCardContent, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceCardTextBox, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceDescription, {
                                                        children: "내가 원하는 병원을\n쉽고 빠르게!"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceTitle, {
                                                        children: "가까운 병원 찾기"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                                children: "바로 가기"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                        src: "https://file.doctornow.co.kr/landing/hospital-sign-icon.png",
                                        alt: "방문 예약 아이콘"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceCard, {
                                "data-aos": "fade-up",
                                href: "https://doctornow.co.kr/non-benefit?treatmentMedicineUnitId=73&regionCode=11",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceCardContent, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceCardTextBox, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceDescription, {
                                                        children: "내 근처 비급여 성지가\n궁금하다면?"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceTitle, {
                                                        children: "우리동네 진료 가격"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                                children: "바로 가기"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                        src: "https://file.doctornow.co.kr/landing/receipt-icon.png",
                                        alt: "우리동네 진료 가격 아이콘"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_ServiceCardSection = (ServiceCardSection);
var ServiceCardSection_Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fb0bc0dd-0"
})(ServiceCardSection_templateObject(), function(param) {
    var theme = param.theme;
    return theme.color.gray20;
}, layout/* Tablet */.YD);
var ServiceCardSection_Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-fb0bc0dd-1"
})(ServiceCardSection_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n      ".concat(theme.typography.UI48B, ";\n      color: ").concat(theme.color.black, ";\n      \n      @media screen and (max-width: ").concat(layout/* Tablet */.YD, ") {\n        ").concat(theme.typography.UI32B, ";\n      }\n    ");
});
var ServiceCardContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fb0bc0dd-2"
})(ServiceCardSection_templateObject2(), layout/* Tablet */.YD);
var ServiceCardSection_Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fb0bc0dd-3"
})(ServiceCardSection_templateObject3(), layout/* Tablet */.YD);
var ServiceCard = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-fb0bc0dd-4"
})(ServiceCardSection_templateObject4(), layout/* Tablet */.YD);
var Icon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-fb0bc0dd-5"
})(ServiceCardSection_templateObject5(), layout/* Tablet */.YD);
var ServiceCardContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fb0bc0dd-6"
})(ServiceCardSection_templateObject6());
var ServiceCardTextBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fb0bc0dd-7"
})(ServiceCardSection_templateObject7());
var ServiceDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fb0bc0dd-8"
})(ServiceCardSection_templateObject8(), function(param) {
    var theme = param.theme;
    return "\n        ".concat(theme.typography.UI20M, ";\n        color: ").concat(theme.color.gray500, ";\n    ");
});
var ServiceTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-fb0bc0dd-9"
})(ServiceCardSection_templateObject9(), function(param) {
    var theme = param.theme;
    return "\n        ".concat(theme.typography.UI28B, ";\n        color: ").concat(theme.color.gray900, ";\n    ");
});
var Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-fb0bc0dd-10"
})(ServiceCardSection_templateObject10(), function(param) {
    var theme = param.theme;
    return "\n        ".concat(theme.typography.UI16SB, ";\n        background:").concat(theme.color.primary100, ";\n        color: ").concat(theme.color.primary700, ";\n    ");
});

;// CONCATENATED MODULE: ./src/components/templates/landing/components/LazyVideo.tsx



var LazyVideo = function(param) {
    var src = param.src, className = param.className;
    var videoRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    (0,react.useEffect)(function() {
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
            if (entry.isIntersecting) {
                setIsVisible(true);
                observer.disconnect();
            }
        }, {
            rootMargin: "200px"
        });
        if (videoRef.current) {
            observer.observe(videoRef.current);
        }
        return function() {
            return observer.disconnect();
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
        ref: videoRef,
        autoPlay: true,
        playsInline: true,
        loop: true,
        muted: true,
        className: className,
        style: {
            maskImage: "linear-gradient(white, black)",
            WebkitMaskImage: "linear-gradient(white, black)",
            backfaceVisibility: "hidden",
            WebkitBackfaceVisibility: "hidden"
        },
        children: isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
            src: src,
            type: "video/mp4"
        })
    });
};
/* harmony default export */ var components_LazyVideo = (LazyVideo);

;// CONCATENATED MODULE: ./src/components/templates/landing/components/ServiceInstructionSection.tsx

function ServiceInstructionSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 160px 0;\n  flex-direction: column;\n  align-items: center;\n  gap: 142px;\n  align-self: stretch;\n  background: white;\n\n  @media screen and (max-width: ",
        ") {\n    gap: 0;\n    padding: 0 0 32px 0;\n  }\n"
    ]);
    ServiceInstructionSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ServiceInstructionSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 1080px;\n  display: flex;\n  padding: 0 20px;\n  justify-content: space-between;\n  align-items: center;\n\n  @media screen and (max-width: ",
        ") {\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 28px;\n    padding: 72px 0 40px 0;\n  }\n"
    ]);
    ServiceInstructionSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ServiceInstructionSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: row-reverse;\n\n  @media screen and (max-width: ",
        ") {\n    flex-direction: column;\n  }\n"
    ]);
    ServiceInstructionSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ServiceInstructionSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  width: 480px;\n  overflow: hidden;\n\n  @media screen and (max-width: ",
        ") {\n    width: 280px;\n  }\n"
    ]);
    ServiceInstructionSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ServiceInstructionSection_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 500px;\n  height: 10px;\n  background: linear-gradient(\n    180deg,\n    rgba(255, 255, 255, 0) 2.08%,\n    #fff 69.74%\n  );\n\n  left: -25px;\n  bottom: 0;\n"
    ]);
    ServiceInstructionSection_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ServiceInstructionSection_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 420px;\n  gap: 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  @media screen and (max-width: ",
        ") {\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n  }\n"
    ]);
    ServiceInstructionSection_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ServiceInstructionSection_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: flex-start;\n  display: flex;\n  padding: 5px 12px;\n  flex-direction: column;\n  align-items: flex-start;\n\n  ",
        ";\n  @media screen and (max-width: ",
        ") {\n    align-self: center;\n  }\n"
    ]);
    ServiceInstructionSection_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ServiceInstructionSection_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: pre-wrap;\n  ",
        "\n"
    ]);
    ServiceInstructionSection_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ServiceInstructionSection_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: pre-wrap;\n  margin-top: 3px;\n  ",
        "\n"
    ]);
    ServiceInstructionSection_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var ServiceInstructionSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceInstructionSection_Section, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceInstructionSection_Row, {
                "data-aos": "fade-up",
                "data-aos-duration": 500,
                "data-aos-once": "true",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LazyVideo, {
                                src: "https://file.doctornow.co.kr/landing/doctor-select-step.mp4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradation, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentBox, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Step, {
                                children: "진료 예약"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceInstructionSection_Title, {
                                children: "내가 직접 선택하는\n의사 선생님"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                                children: "평균 진료비와 진료 후기를 보고\n원하는 의사 선생님을 골라보세요."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowReverse, {
                "data-aos": "fade-up",
                "data-aos-duration": 500,
                "data-aos-once": "true",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LazyVideo, {
                                src: "https://file.doctornow.co.kr/landing/diagnosis-detail-step.mp4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradation, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentBox, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Step, {
                                children: "전화로 비대면 진료"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceInstructionSection_Title, {
                                children: "언제 어디서나\n편하게 진료"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                                children: "365일 24시간 언제든\n전화로 진료받을 수 있어요."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceInstructionSection_Row, {
                "data-aos": "fade-up",
                "data-aos-duration": 500,
                "data-aos-once": "true",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LazyVideo, {
                                src: "https://file.doctornow.co.kr/landing/send-prescription-step.mp4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradation, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentBox, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Step, {
                                children: "약 픽업"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceInstructionSection_Title, {
                                children: "처방전은 앱으로 전송하고\n바로 약국에서 픽업"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                                children: "간편하게 조제 신청하고\n대기 없이 약을 바로 찾아올 수 있어요."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_ServiceInstructionSection = (ServiceInstructionSection);
var ServiceInstructionSection_Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1667be1-0"
})(ServiceInstructionSection_templateObject(), layout/* Tablet */.YD);
var ServiceInstructionSection_Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1667be1-1"
})(ServiceInstructionSection_templateObject1(), layout/* Tablet */.YD);
var RowReverse = (0,styled_components_browser_esm/* default */.ZP)(ServiceInstructionSection_Row).withConfig({
    componentId: "sc-b1667be1-2"
})(ServiceInstructionSection_templateObject2(), layout/* Tablet */.YD);
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1667be1-3"
})(ServiceInstructionSection_templateObject3(), layout/* Tablet */.YD);
var Gradation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1667be1-4"
})(ServiceInstructionSection_templateObject4());
var ContentBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1667be1-5"
})(ServiceInstructionSection_templateObject5(), layout/* Tablet */.YD);
var Step = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1667be1-6"
})(ServiceInstructionSection_templateObject6(), function(param) {
    var theme = param.theme;
    return "\n        border-radius: 20px;\n        background: ".concat(theme.color.primary100, ";\n        color: ").concat(theme.color.primary600, ";\n        ").concat(theme.typography.UI20SB, ";\n        \n        @media screen and (max-width: ").concat(layout/* Tablet */.YD, ") {\n          ").concat(theme.typography.UI17SB, ";\n        };\n    ");
}, layout/* Tablet */.YD);
var ServiceInstructionSection_Title = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-b1667be1-7"
})(ServiceInstructionSection_templateObject7(), function(param) {
    var theme = param.theme;
    return "\n        ".concat(theme.typography.UI40B, ";\n        color: ").concat(theme.color.gray900, ";\n        \n        @media screen and (max-width: ").concat(layout/* Tablet */.YD, ") {\n          ").concat(theme.typography.UI28B, ";\n        }\n    ");
});
var Description = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1667be1-8"
})(ServiceInstructionSection_templateObject8(), function(param) {
    var theme = param.theme;
    return "\n        ".concat(theme.typography.UI20R, ";\n        color: ").concat(theme.color.gray500, ";\n        \n        @media screen and (max-width: ").concat(layout/* Tablet */.YD, ") {\n          ").concat(theme.typography.UI17R, ";\n        }\n    ");
});

;// CONCATENATED MODULE: ./src/components/templates/landing/components/ServiceStepSection.tsx

function ServiceStepSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 68px;\n  padding: 100px 20px 120px 20px;\n  align-items: center;\n  ",
        ";\n\n  @media screen and (max-width: ",
        ") {\n    padding: 80px 20px;\n  }\n"
    ]);
    ServiceStepSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ServiceStepSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n\n  @media screen and (max-width: ",
        ") {\n    ",
        "\n  }\n"
    ]);
    ServiceStepSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ServiceStepSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  max-width: 1080px;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: stretch;\n\n  @media screen and (max-width: ",
        ") {\n    flex-direction: column;\n    width: 100%;\n    align-items: stretch;\n    justify-contents: stretch;\n    gap: 20px;\n  }\n"
    ]);
    ServiceStepSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ServiceStepSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  word-break: keep-all;\n  text-align: center;\n  width: 32%;\n  background-color: white;\n  border-radius: 20px;\n  padding: 32px 32px 32px 32px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  box-shadow: 0 2px 40px 0 rgba(0, 0, 0, 0.06);\n  gap: 20px;\n\n  @media screen and (max-width: ",
        ") {\n    width: 100%;\n  }\n"
    ]);
    ServiceStepSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ServiceStepSection_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 0;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n  align-self: stretch;\n"
    ]);
    ServiceStepSection_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ServiceStepSection_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 38px;\n  padding: 0 20px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 23px;\n\n  ",
        "\n"
    ]);
    ServiceStepSection_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ServiceStepSection_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    ServiceStepSection_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ServiceStepSection_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 120px;\n  height: 120px;\n  margin-top: auto;\n\n  @media screen and (max-width: ",
        ") {\n    width: 100px;\n    height: 100px;\n  }\n"
    ]);
    ServiceStepSection_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var ServiceStepSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceStepSection_Section, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceStepSection_Title, {
                children: "닥터나우, 어렵지 않아요"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                        "data-aos": "fade-up",
                        "data-aos-duration": 500,
                        "data-aos-once": "true",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardTextContent, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceStepSection_Step, {
                                        children: "STEP 1"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceStepSection_Label, {
                                        children: "진료 예약하기"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceStepSection_Icon, {
                                src: "https://file.doctornow.co.kr/landing/calendar-icon.png",
                                alt: "달력 아이콘"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                        "data-aos": "fade-up",
                        "data-aos-duration": 1500,
                        "data-aos-once": "true",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardTextContent, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceStepSection_Step, {
                                        children: "STEP 2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceStepSection_Label, {
                                        children: "전화로 진료받기"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceStepSection_Icon, {
                                src: "https://file.doctornow.co.kr/landing/call-icon.png",
                                alt: "전화 아이콘"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                        "data-aos": "fade-up",
                        "data-aos-duration": 2000,
                        "data-aos-once": "true",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardTextContent, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceStepSection_Step, {
                                        children: "STEP 3"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceStepSection_Label, {
                                        children: "약 픽업하기"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceStepSection_Icon, {
                                src: "https://file.doctornow.co.kr/landing/pill-package-icon.png",
                                alt: "알약 아이콘"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_ServiceStepSection = (ServiceStepSection);
var ServiceStepSection_Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1d89e9ab-0"
})(ServiceStepSection_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.gray20, ";\n  ");
}, layout/* Tablet */.YD);
var ServiceStepSection_Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-1d89e9ab-1"
})(ServiceStepSection_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n      color: ".concat(theme.color.gray900, ";\n      ").concat(theme.typography.UI48B, ";\n    ");
}, layout/* Tablet */.YD, function(param) {
    var theme = param.theme;
    return "\n       width: 200px;\n      ".concat(theme.typography.UI32B, ";\n      text-align: center;\n      align-self: center;\n    ");
});
var CardRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1d89e9ab-2"
})(ServiceStepSection_templateObject2(), layout/* Tablet */.YD);
var Card = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1d89e9ab-3"
})(ServiceStepSection_templateObject3(), layout/* Tablet */.YD);
var CardTextContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1d89e9ab-4"
})(ServiceStepSection_templateObject4());
var ServiceStepSection_Step = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1d89e9ab-5"
})(ServiceStepSection_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n      background: ".concat(theme.color.primary600, ";\n      color: ").concat(theme.color.white, ";\n      ").concat(theme.typography.UI18SB, ";\n      \n      @media screen and (max-width: ").concat(layout/* Tablet */.YD, ") {\n       ").concat(theme.typography.UI16SB, "; \n      }\n    ");
});
var ServiceStepSection_Label = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-1d89e9ab-6"
})(ServiceStepSection_templateObject6(), function(param) {
    var theme = param.theme;
    return "\n      color: ".concat(theme.color.gray900, ";\n      ").concat(theme.typography.UI28B, ";\n    ");
});
var ServiceStepSection_Icon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-1d89e9ab-7"
})(ServiceStepSection_templateObject7(), layout/* Tablet */.YD);

;// CONCATENATED MODULE: ./src/widgets/main-banner/ui/BannerDescription.tsx

var BannerDescription = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col justify-between gap-y-[40px] sm:flex-row",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "typography-ui-17m md:typography-ui-22m flex flex-col gap-y-[4px] text-gray-500",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "대한민국 1위 비대면 진료 앱 닥터나우가"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "아픈 모든 순간 어디서든 곁에 있어요."
                })
            ]
        })
    });
};
/* harmony default export */ var ui_BannerDescription = (BannerDescription);

;// CONCATENATED MODULE: ./src/widgets/main-banner/lib/bannerData.ts
var bannerDataList = [
    {
        id: 1,
        title: "이불 밖은 더 아플 때",
        subtitle: "병원에서 전화가 와요",
        imageUrl: "https://media.doctornow.co.kr/home_main_banner_sick_in_bed.webp",
        imageAlt: "침대에서 아픈 환자가 휴식을 취하는 모습"
    },
    {
        id: 2,
        title: "바빠서 꼼짝 못할 때",
        subtitle: "병원에서 전화가 와요",
        imageUrl: "https://media.doctornow.co.kr/home_main_banner_busy_office.webp",
        imageAlt: "바쁜 업무 중인 직장인이 스트레스를 받는 모습"
    },
    {
        id: 3,
        title: "먹던 약 떨어졌을 때",
        subtitle: "병원에서 전화가 와요",
        imageUrl: "https://media.doctornow.co.kr/home_main_banner_medicine_hand.webp",
        imageAlt: "손에 약을 들고 있는 모습"
    },
    {
        id: 4,
        title: "소아과 대기가 길 때",
        subtitle: "병원에서 전화가 와요",
        imageUrl: "https://media.doctornow.co.kr/home_main_banner_pediatric_clinic.webp",
        imageAlt: "소아과 진료실에서 아이와 의료진이 있는 모습"
    }, 
];

;// CONCATENATED MODULE: ./src/widgets/main-banner/ui/BannerTitle.tsx


var BannerTitle = function(param) {
    var currentBanner = param.currentBanner;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "typography-ui-32b sm:typography-ui-56b mb-[16px] w-full text-gray-900 sm:mb-[24px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative h-[40px] overflow-hidden sm:h-[70px]",
                children: bannerDataList.map(function(banner, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "gif absolute block w-full text-left text-primary-700",
                        id: index === 0 ? undefined : "g".concat(index + 1),
                        children: banner.title
                    }, banner.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-gray-900",
                children: currentBanner.subtitle
            })
        ]
    });
};
/* harmony default export */ var ui_BannerTitle = (BannerTitle);

;// CONCATENATED MODULE: ./src/widgets/main-banner/ui/BannerContent.tsx



var BannerContent = function(param) {
    var currentBanner = param.currentBanner;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex w-full flex-1 flex-col pt-[32px] sm:pt-[28px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_BannerTitle, {
                currentBanner: currentBanner
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_BannerDescription, {})
        ]
    });
};
/* harmony default export */ var ui_BannerContent = (BannerContent);

;// CONCATENATED MODULE: ./src/widgets/main-banner/lib/constants.ts
var BANNER_CONFIG = {
    ANIMATION_DURATION: 850,
    BANNER_INTERVAL: 3000,
    IMAGE_TRANSITION_DELAY: 850
};
var BANNER_DIMENSIONS = {
    MOBILE: {
        MIN_HEIGHT: 180,
        BORDER_RADIUS: 8
    },
    TABLET: {
        MIN_HEIGHT: 280,
        HEIGHT: 572,
        BORDER_RADIUS: 32
    },
    DESKTOP: {
        HEIGHT: 320,
        MIN_HEIGHT: 320,
        MAX_WIDTH: 500,
        BORDER_RADIUS: 32
    }
};
var BANNER_SPACING = {
    MOBILE: {
        PADDING_X: 20,
        PADDING_BOTTOM: 48,
        PADDING_TOP: 32,
        GAP: 40,
        TITLE_MARGIN_BOTTOM: 16,
        SECTION_MARGIN_BOTTOM: 12
    },
    TABLET: {
        PADDING_X: 0,
        PADDING_Y: 80,
        PADDING_TOP: 28,
        GAP: 40,
        TITLE_MARGIN_BOTTOM: 24,
        SECTION_MARGIN_BOTTOM: 24
    },
    DESKTOP: {
        GAP: 56,
        PADDING_BOTTOM: 80
    }
};
var BANNER_ANIMATION_DELAYS = {
    SECOND_BANNER: -9,
    THIRD_BANNER: -6,
    FOURTH_BANNER: -3
};

;// CONCATENATED MODULE: ./src/widgets/main-banner/ui/BannerImage.tsx



var BannerImage = function(param) {
    var currentBanner = param.currentBanner;
    var ref = (0,react.useState)(currentBanner.imageUrl), displayImage = ref[0], setDisplayImage = ref[1];
    var ref1 = (0,react.useState)(currentBanner.imageUrl), nextImage = ref1[0], setNextImage = ref1[1];
    var ref2 = (0,react.useState)(false), isImageAnimating = ref2[0], setIsImageAnimating = ref2[1];
    (0,react.useEffect)(function() {
        if (displayImage !== currentBanner.imageUrl) {
            setNextImage(currentBanner.imageUrl);
            setIsImageAnimating(true);
            setTimeout(function() {
                setDisplayImage(currentBanner.imageUrl);
                setIsImageAnimating(false);
            }, BANNER_CONFIG.IMAGE_TRANSITION_DELAY);
        }
    }, [
        currentBanner.imageUrl,
        displayImage
    ]);
    var getImageClasses = function() {
        var isNext = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var baseClasses = "absolute top-0 left-0 h-full w-full rounded-[12px] object-cover";
        if (isNext) {
            return "".concat(baseClasses, " ").concat(isImageAnimating ? "slide-in-right" : "translate-x-[100px] opacity-0");
        }
        return "".concat(baseClasses, " ").concat(isImageAnimating ? "slide-out-left" : "translate-x-0 opacity-100");
    };
    var getImageStyle = function() {
        return {
            transition: isImageAnimating ? "none" : "all 0.3s ease"
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative desktop:h-[320px] h-[180px] w-full desktop:max-w-[500px] overflow-hidden rounded-[12px] sm:h-[280px] md:h-[572px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: displayImage,
                alt: currentBanner.imageAlt,
                className: getImageClasses(),
                style: getImageStyle()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: nextImage,
                alt: currentBanner.imageAlt,
                className: getImageClasses(true),
                style: getImageStyle()
            })
        ]
    });
};
/* harmony default export */ var ui_BannerImage = (BannerImage);

;// CONCATENATED MODULE: ./src/widgets/main-banner/hooks/useMainBannerViewModel.ts



var useMainBannerViewModel = function() {
    var ref = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(0), currentBannerIndex = ref1[0], setCurrentBannerIndex = ref1[1];
    var ref2 = (0,react.useState)(bannerDataList[0]), currentBanner = ref2[0], setCurrentBanner = ref2[1];
    (0,react.useEffect)(function() {
        var interval = setInterval(function() {
            setCurrentBannerIndex(function(prevIndex) {
                var nextIndex = (prevIndex + 1) % bannerDataList.length;
                setCurrentBanner(bannerDataList[nextIndex]);
                return nextIndex;
            });
        }, BANNER_CONFIG.BANNER_INTERVAL);
        return function() {
            return clearInterval(interval);
        };
    }, []);
    return {
        ref: ref,
        currentBanner: currentBanner,
        currentBannerIndex: currentBannerIndex
    };
};
/* harmony default export */ var hooks_useMainBannerViewModel = (useMainBannerViewModel);

;// CONCATENATED MODULE: ./src/widgets/main-banner/ui/MainBannerAnimations.tsx

function MainBannerAnimations_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      &::before {\n        position: absolute;\n        width: 0;\n        height: 0;\n        overflow: hidden;\n        z-index: -1;\n\n        content: url('https://file.doctornow.co.kr/landing/catchphrase.png')\n          url('https://file.doctornow.co.kr/landing/cf-web-main-thumbnail.jpg');\n      }\n    "
    ]);
    MainBannerAnimations_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MainBannerAnimations_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100vw;\n  background-size: cover;\n  background-position: center;\n  background-color: white;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  isolation: isolate;\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  .slide-up {\n    animation: slide-up 0.85s cubic-bezier(0.65, 0, 0.35, 1) both;\n  }\n\n  .slide-down {\n    animation: slide-down 0.85s cubic-bezier(0.65, 0, 0.35, 1) both;\n  }\n\n  .slide-in-right {\n    animation: slide-in-right 0.85s cubic-bezier(0.65, 0, 0.35, 1) both;\n  }\n\n  .slide-out-left {\n    animation: slide-out-left 0.85s cubic-bezier(0.65, 0, 0.35, 1) both;\n  }\n\n  .gif {\n    position: absolute;\n    width: 100%;\n    top: 50%;\n    animation: fadeslideUp 12s infinite;\n  }\n\n  #g2 {\n    animation-delay: ",
        "s;\n  }\n\n  #g3 {\n    animation-delay: ",
        "s;\n  }\n\n  #g4 {\n    animation-delay: ",
        "s;\n  }\n\n  @media screen and (max-width: ",
        ") {\n    width: 100%;\n    background-color: white;\n  }\n\n  ",
        "\n"
    ]);
    MainBannerAnimations_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var slideUpKeyframes = "\n  @keyframes slide-up {\n    0% {\n      transform: translateY(100px);\n      opacity: 0;\n    }\n    100% {\n      transform: translateY(0);\n      opacity: 1;\n    }\n  }\n";
var slideDownKeyframes = "\n  @keyframes slide-down {\n    0% {\n      transform: translateY(0);\n      opacity: 1;\n    }\n    100% {\n      transform: translateY(100px);\n      opacity: 0;\n    }\n  }\n";
var slideInRightKeyframes = "\n  @keyframes slide-in-right {\n    0% {\n      transform: translateX(100px);\n      opacity: 0;\n    }\n    100% {\n      transform: translateX(0);\n      opacity: 1;\n    }\n  }\n";
var slideOutLeftKeyframes = "\n  @keyframes slide-out-left {\n    0% {\n      transform: translateX(0);\n      opacity: 1;\n    }\n    100% {\n      transform: translateX(-100px);\n      opacity: 0;\n    }\n  }\n";
var fadeslideUpKeyframes = "\n  @keyframes fadeslideUp {\n    0% {\n      opacity: 0;\n      transform: translateY(-40%);\n    }\n    6.25% {\n      opacity: 1;\n      transform: translateY(-50%);\n    }\n    18.75% {\n      opacity: 1;\n      transform: translateY(-50%);\n    }\n    25% {\n      opacity: 0;\n      transform: translateY(-60%);\n    }\n    100% {\n      opacity: 0;\n      transform: translateY(-60%);\n    }\n  }\n";
var MainBannerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9d102b45-0"
})(MainBannerAnimations_templateObject1(), slideUpKeyframes, slideDownKeyframes, slideInRightKeyframes, slideOutLeftKeyframes, fadeslideUpKeyframes, BANNER_ANIMATION_DELAYS.SECOND_BANNER, BANNER_ANIMATION_DELAYS.THIRD_BANNER, BANNER_ANIMATION_DELAYS.FOURTH_BANNER, layout/* Tablet */.YD, function(param) {
    var theme = param.theme;
    return !theme.client.isMobile && (0,styled_components_browser_esm/* css */.iv)(MainBannerAnimations_templateObject());
});

;// CONCATENATED MODULE: ./src/features/medical-category-display/lib/constants.ts
var MEDICAL_CATEGORY_CONFIG = {
    DEFAULT_DISPLAY_SIZE: 10,
    SKELETON_COUNT: 10
};
var CATEGORY_GRID_STYLES = {
    CONTAINER: "flex w-full flex-col",
    GRID: "grid grid-cols-5 gap-0 px-[12px] md:px-[0px] sm:grid-cols-10 sm:gap-[24px]",
    ITEM_BASE: "flex min-h-[88px] cursor-pointer flex-col items-center justify-center gap-[12px] rounded-[8px] border border-gray-100 p-[8px] sm:min-h-[108px] aspect-square",
    SKELETON_ITEM: "flex w-full cursor-pointer flex-col items-center justify-center gap-[12px] rounded-[8px] border border-gray-100 p-[8px] sm:min-h-[108px] aspect-square"
};
var CATEGORY_ITEM_STYLES = {
    ICON_CONTAINER: "flex aspect-square h-[48px] w-[48px] sm:h-[64px] sm:w-[64px] items-center justify-center rounded-[16px] sm:rounded-[21px] bg-gray-20 p-[12%] sm:p-[20%] md:p-[18%] lg:p-[20%]",
    ICON: "h-full w-full object-contain",
    NAME: "typography-ui-13m sm:typography-ui-17m flex h-[16px] items-center justify-center whitespace-nowrap break-keep text-center text-gray-700 leading-tight sm:h-[20px]"
};
var SKELETON_STYLES = {
    ICON_CONTAINER: "flex aspect-square h-[48px] w-[48px] sm:h-[64px] sm:w-[64px] items-center justify-center rounded-[21px] bg-gray-50 p-[20%]",
    ICON_PLACEHOLDER: "aspect-square bg-gray-50",
    NAME_PLACEHOLDER: "h-[16px] w-[48px] rounded-[4px] bg-gray-50 sm:h-[20px] sm:w-[64px]"
};

;// CONCATENATED MODULE: ./src/features/medical-category-display/ui/CategoryItemSkeleton.tsx


var CategoryItemSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex min-h-[88px] w-full flex-col items-center justify-center gap-[12px] rounded-[8px] p-[8px] sm:min-h-[108px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: SKELETON_STYLES.ICON_CONTAINER
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: SKELETON_STYLES.NAME_PLACEHOLDER
            })
        ]
    });
};
/* harmony default export */ var ui_CategoryItemSkeleton = (CategoryItemSkeleton);

;// CONCATENATED MODULE: ./src/features/medical-category-display/ui/CategoryGrid.tsx



var CategoryGrid = function(param) {
    var children = param.children, isLoading = param.isLoading;
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: CATEGORY_GRID_STYLES.CONTAINER,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: CATEGORY_GRID_STYLES.GRID,
                children: Array.from({
                    length: MEDICAL_CATEGORY_CONFIG.SKELETON_COUNT
                }).map(function(_, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_CategoryItemSkeleton, {}, index);
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: CATEGORY_GRID_STYLES.CONTAINER,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: CATEGORY_GRID_STYLES.GRID,
            children: children
        })
    });
};
/* harmony default export */ var ui_CategoryGrid = (CategoryGrid);

// EXTERNAL MODULE: ./src/components/common/ClickLogger.tsx
var ClickLogger = __webpack_require__(53157);
;// CONCATENATED MODULE: ./src/features/medical-category-display/ui/CategoryItem.tsx



var CategoryItem = function(param) {
    var category = param.category, onClickCategory = param.onClickCategory;
    var _id, _iconUrl, _name, _name1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
        params: {
            eventName: "category_item_click",
            payload: {
                categoryId: (_id = category.id) !== null && _id !== void 0 ? _id : ""
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "cursor-pointer",
            onClick: onClickCategory,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: "flex min-h-[88px] cursor-pointer flex-col items-center justify-center gap-[12px] rounded-[8px] p-[8px] sm:min-h-[108px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: CATEGORY_ITEM_STYLES.ICON_CONTAINER,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (_iconUrl = category.iconUrl) !== null && _iconUrl !== void 0 ? _iconUrl : "",
                            alt: (_name = category.name) !== null && _name !== void 0 ? _name : "",
                            className: CATEGORY_ITEM_STYLES.ICON
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: CATEGORY_ITEM_STYLES.NAME,
                        children: (_name1 = category.name) !== null && _name1 !== void 0 ? _name1 : ""
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var ui_CategoryItem = (CategoryItem);

// EXTERNAL MODULE: ./src/types/common.ts
var types_common = __webpack_require__(70138);
;// CONCATENATED MODULE: ./src/features/medical-category-display/hooks/useMedicalCategoryDisplayViewModel.ts




var MORE_CATEGORY_PATH = "".concat(types_common/* ROUTES.TELEMEDICINE.CATEGORIES.path */.Z6.TELEMEDICINE.CATEGORIES.path);
var MORE_CATEGORY = {
    id: "more",
    name: "전체 보기",
    iconUrl: "https://d2m9duoqjhyhsq.cloudfront.net/diagnoses/etc/more_category.png"
};
var useMedicalCategoryDisplayViewModel = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : MEDICAL_CATEGORY_CONFIG.DEFAULT_DISPLAY_SIZE - 1;
    var onClickTelemedicineRequest = (0,telemedicine/* useTelemedicineRequest */.UO)().onClickTelemedicineRequest;
    var ref = (0,medical_category/* useNonF2fMedicalCategories */.tC)(size), medicalCategories = ref.medicalCategories, isLoading = ref.isLoading, error = ref.error;
    var getCategoryPath = function(category) {
        return (0,telemedicine/* getCategoryPath */.IX)(category.id, category.category);
    };
    var onClickCategory = function(category) {
        onClickTelemedicineRequest({
            categoryId: category.id,
            type: category.category,
            redirectUrl: (0,telemedicine/* getCategoryPath */.IX)(category.id, category.category)
        });
    };
    return {
        medicalCategories: medicalCategories,
        moreCategory: MORE_CATEGORY,
        isLoading: isLoading,
        error: error,
        moreCategoryPath: MORE_CATEGORY_PATH,
        getCategoryPath: getCategoryPath,
        onClickCategory: onClickCategory
    };
};
/* harmony default export */ var hooks_useMedicalCategoryDisplayViewModel = (useMedicalCategoryDisplayViewModel);

;// CONCATENATED MODULE: ./src/features/medical-category-display/ui/MedicalCategoryGrid.tsx







var MedicalCategoryGrid = function() {
    var viewModel = hooks_useMedicalCategoryDisplayViewModel(MEDICAL_CATEGORY_CONFIG.DEFAULT_DISPLAY_SIZE);
    var _iconUrl, _name, _name1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_CategoryGrid, {
        isLoading: viewModel.isLoading,
        children: [
            viewModel.medicalCategories.map(function(category) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_CategoryItem, {
                    category: category,
                    onClickCategory: function() {
                        return viewModel.onClickCategory(category);
                    }
                }, category.id);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                params: {
                    eventName: "category_item_click",
                    payload: {
                        categoryId: viewModel.moreCategory.id
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: viewModel.moreCategoryPath,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: "flex min-h-[88px] cursor-pointer flex-col items-center justify-center gap-[12px] rounded-[8px] p-[8px] sm:min-h-[108px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: CATEGORY_ITEM_STYLES.ICON_CONTAINER,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (_iconUrl = viewModel.moreCategory.iconUrl) !== null && _iconUrl !== void 0 ? _iconUrl : "",
                                    alt: (_name = viewModel.moreCategory.name) !== null && _name !== void 0 ? _name : "",
                                    className: CATEGORY_ITEM_STYLES.ICON
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: CATEGORY_ITEM_STYLES.NAME,
                                children: (_name1 = viewModel.moreCategory.name) !== null && _name1 !== void 0 ? _name1 : ""
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ui_MedicalCategoryGrid = (MedicalCategoryGrid);

;// CONCATENATED MODULE: ./src/features/medical-category-display/index.ts






;// CONCATENATED MODULE: ./src/widgets/main-banner/ui/MedicalCategorySection.tsx


var MedicalCategorySection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-[12px] flex px-[24px] sm:mb-[24px] md:px-[0px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "typography-ui-20sb sm:typography-ui-22sb text-center text-gray-800",
                    children: "비대면 진료 시작하기"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicalCategoryGrid, {})
            })
        ]
    });
};
/* harmony default export */ var ui_MedicalCategorySection = (MedicalCategorySection);

;// CONCATENATED MODULE: ./src/widgets/main-banner/ui/MainBanner.tsx







var MainBanner = function() {
    var ref = hooks_useMainBannerViewModel(), ref1 = ref.ref, currentBanner = ref.currentBanner;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainBannerContainer, {
        ref: ref1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex w-full max-w-[1080px] flex-col desktop:pt-[80px] pb-[80px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative flex w-full flex-1 desktop:flex-row flex-col justify-between desktop:gap-[56px] gap-[40px] px-[20px] desktop:py-[80px] pb-[48px] sm:flex-col sm:gap-[40px] sm:px-[0px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_BannerContent, {
                            currentBanner: currentBanner
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_BannerImage, {
                            currentBanner: currentBanner
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicalCategorySection, {})
            ]
        })
    });
};
/* harmony default export */ var ui_MainBanner = (MainBanner);

;// CONCATENATED MODULE: ./src/widgets/main-banner/index.ts








;// CONCATENATED MODULE: ./src/views/landing-page/hooks/useLandingPageViewModel.tsx

var nestedReviews = [
    [
        {
            tag: "감기/몸살",
            icon: "https://file.doctornow.co.kr/landing/tag-cold.png",
            alt: "감기/몸살",
            title: "아파서 움직일 수 없을 때 한 줄기 빛!",
            content: "움직일 수조차 없이 아파서 선택지가 없었는데 처방해주신 약 먹고 한숨 자고 일어났더니 안정을 찾았어요. 참고로 약도 엄마가 찾아와 주셨어요! 이런 앱도 있다는 것을 널리 알리고 싶어요!",
            author: "이00 님"
        },
        {
            tag: "근육통",
            icon: "https://file.doctornow.co.kr/landing/tag-pain.png",
            alt: "근육통",
            title: "이제 멀어서 병원 못 갈 걱정은 없어요.",
            content: "살면서 봬온 선생님 중 가장 친절하셨습니다. 이해하기 쉽도록 정말 자세히 설명해주셨고 이렇게 좋으신 선생님께 진료받아서 감사했습니다. 병원 가까이 거주하시는 분들이 정말 부럽네요 :)",
            author: "이00 님"
        },
        {
            tag: "탈모",
            icon: "https://file.doctornow.co.kr/landing/tag-comb.png",
            alt: "탈모",
            title: "병원가기 어려운 직장인에게 최고의 어플!",
            content: "직장인이라 병원 가기가 너무 어려운데, 다니는 병원이 너무 멀어서 어려움을 겪던 차에 비대면 진료를 받게 되었습니다. 우려하던 것과 달리 원장선생님이 친절하고 세심하게 상담해주셨어요. 다음에 또 뵐 수 있었음 좋겠습니다!",
            author: "변00 님"
        },
        {
            tag: "다이어트",
            icon: "https://file.doctornow.co.kr/landing/tag-diet.png",
            alt: "다이어트",
            title: "지인 추천으로 다이어트 진료 받았어요.",
            content: "다이어트 성공한 지인 추천으로 진료 받아봤습니다. 약은 처음인데 원장님께서 친절하게 잘 설명해주셨어요. 식단과 약을 같이 병행할 예정인데 한달 뒤에 성공 후기 남길 수 있으면 좋겠습니다.",
            author: "김00 님"
        },
        {
            tag: "다래끼/눈 충혈",
            icon: "https://file.doctornow.co.kr/landing/tag-eye.png",
            alt: "다래끼/눈 충혈",
            title: "비 오는 날 외출 안하고 바로 진료 가능!",
            content: "비가 너무 많이 와서 닥터나우로 진료받았어요. 별생각 없이 리뷰 좋아서 병원 선택했는데 진짜 선생님 너무너무 좋습니다! 진심으로 추천합니다! 상태도 꼼꼼하게 잘 물어봐 주시고 비대면 아닌 줄 알았어요.",
            author: "지00 님"
        },
        {
            tag: "여성질환",
            icon: "https://file.doctornow.co.kr/landing/tag-woman.png",
            alt: "여성질환",
            title: "병원가기 민망했는데 비대면 진료로 해결!",
            content: "자세히 설명해주셔서 대면 진료받은 느낌이에요. 질염이 정말 지긋지긋한데 병원까지 가기 망설여지더라고요. 산부인과 가면 오래 대기해야 하기도 하고요. 자세하게 물어봐 주셔서 신뢰도가 급상승했어요.",
            author: "지00 님"
        }, 
    ],
    [
        {
            tag: "통증",
            icon: "https://file.doctornow.co.kr/landing/tag-pain.png",
            alt: "통증",
            title: "가족 진료도 섬세하게 잘해주셨어요!",
            content: "지방 소도시라서 병원이 얼마 없는 곳인데 닥터나우 덕분에 밤늦은 시간에도 대기 없이 편하게 진료를 볼 수 있어 매우 좋아요! 진료도 세세하게 잘 봐주시고 늦은 시간이지만 친절하게 진료 봐주셔서 감사드립니다.",
            author: "전00 님"
        },
        {
            tag: "감기/몸살",
            icon: "https://file.doctornow.co.kr/landing/tag-cold.png",
            alt: "감기/몸살",
            title: "병원이 적은 지역이라면 꼭 필요한 어플!",
            content: "지방 소도시라서 병원이 얼마 없는 곳인데 닥터나우 덕분에 밤늦은 시간에도 대기 없이 편하게 진료를 볼 수 있어 매우 좋아요! 진료도 세세하게 잘 봐주시고 늦은 시간이지만 친절하게 진료 봐주셔서 감사드립니다.",
            author: "김00 님"
        },
        {
            tag: "소아과",
            icon: "https://file.doctornow.co.kr/landing/tag-baby.png",
            alt: "소아과",
            title: "아이들은 왜 이렇게 연휴에 많이 아플까요?",
            content: "연휴 기간도 교대 근무하는 맞벌이 부부라 애 둘을 데리고 소아과 대기하는 게 쉬운 일이 아니에요. 가벼운 감기라 약을 먹여야 할 것 같아서 비대면진료 처음 받아봤어요. 퇴근 중인 애들 아빠에게 약국에서 약 받아오라 하니 너무 편하네요!",
            author: "김00 님"
        },
        {
            tag: "다이어트",
            icon: "https://file.doctornow.co.kr/landing/tag-diet.png",
            alt: "다이어트",
            title: "휴일에도 걱정없이 진료볼 수 있어요!",
            content: "휴일에 모든 병원이 쉴 때 닥터나우에서 이비인후과 운영하고 있으면서 별점도 높은 선생님 진료를 봤는데 왜 별점이 높은지 알 것 같습니다. 매우 친절하시고 세밀하게 물어봐 주셔서 정확한 처방을 받을 수 있었습니다. 감사합니다!",
            author: "김00 님"
        },
        {
            tag: "비염",
            icon: "https://file.doctornow.co.kr/landing/tag-nose.png",
            alt: "비엽",
            title: "비염으로 힘들었는데 숨쉬기가 편해졌어요.",
            content: "비염으로 늘 고생 중인데 약은 면역이 생겨버려서 걱정이었는데요. 선생님께서 처방해주신 약으로 3~4일만에 확실히 좋아져서 숨쉬기가 편해졌어요!! 친절하게 설명도 해주셔서 감사합니다. 비대면 진료는 처음인데 자주 애용할 것 같아요.",
            author: "지00 님"
        },
        {
            tag: "공황장애",
            icon: "https://file.doctornow.co.kr/landing/tag-mind.png",
            alt: "공황장애",
            title: "새 삶을 얻은 기분이예요.",
            content: "공황장애를 앓은 지 10년이 넘어서 평생 이렇게 살아야만 하는 줄 알았는데 원장님의 미션을 잘 이행하니 전보다 많이 좋아졌네요. 사람들과의 만남도 전보다는 많이 좋아졌습니다. 새 삶을 얻은 기분이네요. 하루하루 감사히 도전하면서 살아 보렵니다.",
            author: "심00 님"
        }, 
    ], 
];
var useLandingPageViewModel = function() {
    var ref = (0,react.useState)(null), openedFaqIndex = ref[0], setOpenedFaqIndex = ref[1];
    var openFaq = function(index) {
        if (index === openedFaqIndex) {
            setOpenedFaqIndex(null);
            return;
        }
        setOpenedFaqIndex(index);
    };
    return {
        nestedReviews: nestedReviews,
        openedFaqIndex: openedFaqIndex,
        openFaq: openFaq
    };
};
/* harmony default export */ var hooks_useLandingPageViewModel = (useLandingPageViewModel);

;// CONCATENATED MODULE: ./src/views/landing-page/ui/LandingPage.tsx


function LandingPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  word-break: keep-all;\n  position: relative;\n  overflow-x: hidden;\n  overscroll-behavior-x: none;\n\n  div {\n    z-index: 2;\n  }\n"
    ]);
    LandingPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var LandingPage = function(param) {
    var client = param.client;
    var viewModel = hooks_useLandingPageViewModel();
    (0,react.useEffect)(function() {
        Promise.allSettled([
            __webpack_require__.e(/* import() */ 3513).then(__webpack_require__.t.bind(__webpack_require__, 53513, 23))
        ]).then(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), aosResult = _param[0];
            if (aosResult.status === "fulfilled") {
                var AOS = aosResult.value;
                AOS.init();
            }
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Screen, {
        children: [
            !client.isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MainHeader, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MainBanner, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ExposeLogger, {
                label: "main_banner",
                client: client
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BrandStorySection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ExposeLogger, {
                label: "brand_story",
                client: client
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ServiceStepSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ExposeLogger, {
                label: "service_step",
                client: client
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ServiceInstructionSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ExposeLogger, {
                label: "service_instruction",
                client: client
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ReviewSection, {
                nestedReviews: viewModel.nestedReviews
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ExposeLogger, {
                label: "review",
                client: client
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ServiceCardSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ExposeLogger, {
                label: "service_card",
                client: client
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FaqSection, {
                selectedFaqIndex: viewModel.openedFaqIndex,
                clickFaq: viewModel.openFaq
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ExposeLogger, {
                label: "faq",
                client: client
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BottomBanner, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ExposeLogger, {
                label: "bottom_banner",
                client: client
            })
        ]
    });
};
/* harmony default export */ var ui_LandingPage = (LandingPage);
var Screen = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b0253dba-0"
})(LandingPage_templateObject());

;// CONCATENATED MODULE: ./src/views/landing-page/lib/constants.ts
var LANDING_PRELOAD_IMAGES = [
    {
        href: "https://media.doctornow.co.kr/home_main_banner_sick_in_bed.webp",
        type: "image/webp"
    },
    {
        href: "https://media.doctornow.co.kr/home_main_banner_busy_office.webp",
        type: "image/webp"
    },
    {
        href: "https://media.doctornow.co.kr/home_main_banner_medicine_hand.webp",
        type: "image/webp"
    },
    {
        href: "https://media.doctornow.co.kr/home_main_banner_pediatric_clinic.webp",
        type: "image/webp"
    },
    {
        href: "https://file.doctornow.co.kr/landing/bottom_banner.png",
        type: "image/png"
    }, 
];

;// CONCATENATED MODULE: ./src/views/landing-page/lib/index.ts



;// CONCATENATED MODULE: ./src/views/landing-page/ui/LandingPageHead.tsx



var LandingPageHead = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
        children: LANDING_PRELOAD_IMAGES.map(function(image) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preload",
                as: "image",
                type: image.type,
                href: image.href
            }, image.href);
        })
    });
};
/* harmony default export */ var ui_LandingPageHead = (LandingPageHead);

;// CONCATENATED MODULE: ./src/views/landing-page/ui/index.ts




;// CONCATENATED MODULE: ./src/views/landing-page/index.ts


;// CONCATENATED MODULE: ./src/pages/index.tsx
// PageDescription: 닥터나우 메인 페이지






var MainSeo = function() {
    var ldJson = (0,format/* createMainPageLdJson */.jV)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                languageAlternates: [
                    {
                        hrefLang: "ja",
                        href: "https://doctornow.jp"
                    },
                    {
                        hrefLang: "ja-JP",
                        href: "https://doctornow.jp"
                    },
                    {
                        hrefLang: "ko",
                        href: "https://doctornow.co.kr"
                    },
                    {
                        hrefLang: "ko-KR",
                        href: "https://doctornow.co.kr"
                    },
                    {
                        hrefLang: "x-default",
                        href: "https://doctornow.co.kr"
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "stylesheet",
                        type: "text/css",
                        href: "https://file.doctornow.co.kr/landing/aos.css"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(ldJson)
                        }
                    })
                ]
            })
        ]
    });
};
var MainPage = function(param) {
    var client = param.client;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_LandingPageHead, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainSeo, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_LandingPage, {
                client: client
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = (MainPage);


/***/ }),

/***/ 76666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cn": function() { return /* binding */ cn; }
/* harmony export */ });
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40489);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98388);


function cn() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_0__/* .twMerge */ .m6)((0,clsx__WEBPACK_IMPORTED_MODULE_1__/* .clsx */ .W)(inputs));
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1498,9774,2888,179], function() { return __webpack_exec__(87314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);